import { useState } from "react";
import QRCodeCard from "../components/features/QRCodeCard";
import CreateQRCodeForm from "../components/features/CreateQRCodeForm";
import UnlockScreen from "../components/features/UnlockScreen";

function QROverview() {
    const [QRCodes, setQRCodes] = useState([]);
    const [access, setAccess] = useState(false);

    return (
        <>
        {
        access
        ? <main id="QRCode-page">
            <div>
                <h1>Lag QR-kode</h1>
                <CreateQRCodeForm setQRCodes={setQRCodes} />
            </div>
            <div>
                <h1>Last ned lagde QR-koder</h1>
                <p><i>(QR-kodene forsvinner om du lukker eller laster inn siden på nytt)</i></p>
                <div id="all-QRcodes-container">
                    {QRCodes.map((location, i) => (
                        <QRCodeCard key={i} location={location} />
                    ))}
                </div>
            </div>
        </main>
        : <UnlockScreen setAccess={setAccess} />
    } </>
    );
};

export default QROverview;